import globalConfirmation from 'live/services/global-confirmation'

import { UPDATE_BUTTON_SAVE_STATUS, UPDATE_RULES_ASSET } from '../constants'
import { getAssetRules, removeRules, saveRules, setGlobalAlert } from '.'

export default (rules = [], sideview = false) => (dispatch, getState) => {
    const {
        dashboardReducer: { batch },
        editorReducer: { assetId, broadcastChannel }
    } = getState()
    const openAlarmsRuleIds = new Set(batch.map(alarm => alarm.ref.ruleId))

    const { selected, localRules } = getState().editorReducer
    const selectedRules = rules.length ? rules : localRules.filter(r => selected.has(r.index))

    globalConfirmation.danger(
        'Are you sure you want to delete the alarm rule' + (selectedRules.length > 1 ? 's' : '') + '?',
        '',
        () => {
            // new (not yet saved) rules are just removed
            const newRulesToBeRemoved = []
            let ruleWithOpenAlarms = null

            const idsToBeDeleted = selectedRules.reduce(
                (obj, rule) => {
                    if (rule.new) {
                        newRulesToBeRemoved.push(rule.index)

                        return obj
                    }

                    if (openAlarmsRuleIds.has(rule.id)) {
                        ruleWithOpenAlarms = rule
                    }

                    const ruleType = rule.global ? 'global' : 'user'

                    return {
                        ...obj,
                        [ruleType]: [...obj[ruleType], rule.id]
                    }
                },
                { global: [], user: [] }
            )

            if (ruleWithOpenAlarms) {
                return dispatch(
                    setGlobalAlert(
                        `Could not delete rule${selectedRules.length > 1 ? 's' : ''} because rule ${
                            ruleWithOpenAlarms.description || '#' + (ruleWithOpenAlarms.index + 1)
                        } would be deleted while there are still open alarms for it`,
                        false
                    )
                )
            }

            dispatch({ type: UPDATE_BUTTON_SAVE_STATUS, status: { saving: true, button: 'delete' } })

            return dispatch(
                saveRules(
                    idsToBeDeleted.user,
                    idsToBeDeleted.global,
                    result => {
                        if (result !== 'error') {
                            if (result === 'success') {
                                dispatch(removeRules(selectedRules.map(r => r.index)))
                            }

                            dispatch(removeRules(newRulesToBeRemoved))

                            if (sideview) {
                                dispatch(getAssetRules(undefined, undefined, undefined, true))
                            } else {
                                broadcastChannel.postMessage({ type: UPDATE_RULES_ASSET, assetId })
                            }
                        }

                        dispatch({ type: UPDATE_BUTTON_SAVE_STATUS, status: { saving: false, button: 'delete' } })
                        dispatch(
                            setGlobalAlert(
                                (result === 'success' ? 'Succesfully deleted' : 'Error deleting') +
                                    ' the selected alarm rule' +
                                    (selectedRules.length > 1 ? 's' : ''),
                                result === 'success'
                            )
                        )
                    },
                    false,
                    true
                )
            )
        }
    )
}
